<template>
<div>
    <b-row class="text-center pt-4">
    </b-row>
    <div class="mt-2">
      <AlertSelectedUnit :selectedUnit="selectedUnit"/>
    </div>
    <hr/>
    <b-alert show :variant="creditStatus.color">
      <h5 class="alert-heading">{{$t('label.creditStatus')}}</h5>
        <hr/>
      <div>{{creditStatus.text}}</div>
    </b-alert>
    <hr/>
    <b-button @click="setNextPage('UpdateApplicantForm')" variant="link" class="mt-3">{{ $t('label.editApplicantForm') }}</b-button>
</div>
</template>

<script>
import AlertSelectedUnit from './AlertSelectedUnit';
export default {
mixins: [],
props: [],
data() { return {}},
computed: {
      creditStatus: function () {
        //let cs = this.$t('info.waitingForAnalysis');  
        let obj = {text: this.$t('info.waitingForAnalysis'), color: "info"}
        let creditStatusList = this.$store.getters.getCreditStatus;
        let process = this.$store.getters.getProcess;     
        if (process[3]) {
          let creditStats = process[3].CreditStatus;
          if (creditStats) {
            let found = creditStatusList.find(cs => cs.Id === creditStats);
            if (found) {
              let lg = this.$i18n.locale;
              obj.text = lg === "fr" ? found.fr : found.en;
              obj.color = creditStats === 5 ? "danger" : "success";
            }
            
          }
        }
        return obj;
      },
      selectedUnit: function () {
      let buldingsList = this.$store.getters.getBuildings;
      let prospectsUnits = this.$store.getters.getProspectsUnits;
      
      let processData1 = this.getProcessData(1);
      let from = "";
      let to = "";

      if (processData1 && processData1.hasOwnProperty('from') && processData1.hasOwnProperty('to')) {
          from = processData1.from;
          to = processData1.to;
      }

      let buildFormat = {};
      if (prospectsUnits.length > 0) {
        let build = buldingsList.find(b => b.NOCIE === prospectsUnits[0].NOCIE && b.NODIV === prospectsUnits[0].NODIV && b.Immeuble.trim() === prospectsUnits[0].IMMEUBLE.trim());
        buildFormat.name = build.NOMDIV+ " ("+  build.Street + ", " + build.City + ", " + build.Province+" )";
        buildFormat.unit = " # " +prospectsUnits[0].UNITE;
        buildFormat.specs = {NBPIECE: prospectsUnits[0].NBPIECE, publicUnitPrice: prospectsUnits[0].publicUnitPrice, DATEENT: from, DATEEND: to};
      }
      
      return buildFormat;
    },
},
methods:{
    getProcessData(int) {
    let processData = this.$store.getters.getProcessData;
    let step0data = processData[int];
    return step0data;
  },
  setNextPage(page) {      
    this.$emit('changePage', page);        
  }
},
components: {
    AlertSelectedUnit
}
}
</script>